module.exports = __webpack_public_path__ + "static/AllianceDuBatiment-3ac90c204a6f92a5d0d005f299934c2a.jpeg";